import React, { useState, useEffect } from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import Sidebar from './sidebarstudent'
import Header from './Headerstudent'
import { Col, Row } from 'react-bootstrap'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import { MDBDataTable } from 'mdbreact'
import { EventDashboardApi, EventDateSelectAttendance } from '../../ApiFile'
import MobileNavbar from './MobileNavbar'

const localizer = momentLocalizer(moment)

function Eventstudent() {

  const year = sessionStorage.getItem('year')
  const [events, setEvents] = useState([])
  const [EventTables, setEventTable] = useState([])
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(`${EventDateSelectAttendance}/${year}`)
        if (response.ok) {
          const data = await response.json()
          const formattedEvents = data.map((event) => ({
            title: event.discription,
            start: moment(
              `${event.event_date} ${event.starttime}`,
              'DD/MM/YYYY HH:mm:ss',
            ).toDate(),
            end: moment(
              `${event.event_date} ${event.starttime}`,
              'DD/MM/YYYY HH:mm:ss',
            )
              .add(1, 'hours')
              .toDate(),
            id: event.event_id,
          }))
          setEvents(formattedEvents)
        } else {
          console.error('Error fetching events: Response not ok')
        }
      } catch (error) {
        console.error('Error fetching events:', error)
      }
    }

    fetchEvents()
  }, [])

  useEffect(() => {
    fetch(`${EventDateSelectAttendance}/${year}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('NOTFOUND')
        }
        return response.json()
      })
      .then((data) => {
        setEventTable(data)
      })
      .catch((error) => {
        if (error.message === 'NOTFOUND') {
          setError('Resource not found')
        } else {
          setError('Add Event')
        }
      })
  }, [EventDateSelectAttendance])

  const tableData = {
    columns: [
      {
        label: 'Serial No',
        field: 'sn',
        sort: 'asc',
      },
      {
        label: 'Event Description',
        field: 'discription',
        sort: 'asc',
      },
      {
        label: 'Event Date',
        field: 'event_date',
        sort: 'asc',
      },
      {
        label: 'Start Time',
        field: 'starttime',
        sort: 'asc',
      },
    ],
    rows: EventTables.map((EventTable, index) => ({
      sn: index + 1,
      discription: EventTable.discription,
      event_date: EventTable.event_date,
      starttime: EventTable.starttime,
    })),
  }

  return (
    <>
     <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar on the left for desktop */}
      <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
        <Sidebar />
      </div>

      {/* Main content on the right */}
      <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
        <Header />

      <div className="d-block d-md-none">
        <MobileNavbar />
      </div>

         <div className="border w-100 h-100 py-3" style={{backgroundColor:"#f5f5f5ff"}}>
          <div className="row m-0 block-header ps-3">
            <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
              Event Calendar
            </h5>
          </div>

          <Row className="px-md-5 mb-5 rounded">
            <Col
              className="px-md-5 py-3 rounded"
              style={{ background: 'white', }}
            >
              <Calendar
                className="w-100 p-lg-5"
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500,overflowX:"auto", }}
              />
            </Col>
          </Row>

          <Row
            className="m-0 px-md-5 py-1 pb-5 mt-3 w-100"
            style={{ display: 'flex' }}
          >
            <Col
              className="m-0 p-0 px-3 py-3 rounded"
              style={{ background: 'white',overflowX: 'auto' }}
            >
              <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
                Events List
              </h5>
              <MDBDataTable
                striped
                bordered
                className="custom-datatable"
                small
                data={tableData}
              />
            </Col>
          </Row>
        </div>
      </div>
      </div>
    </>
  )
}

export default Eventstudent
